<div class="sphere-app-container" #appContainer [class.free]="user && !user.active_subscription">
  @if (helperService.token && user && !userService.isInWelcomeFlow && showHeader) {
    <div>
      <myp-cloud-nav></myp-cloud-nav>
    </div>
  }
  <div id="sphere-app-content" class="sphere-app-content" [class.header-hidden]="!showHeader" (scroll)="appService.sphereAppContentScrolled$.next($event.target.scrollTop)">
    <router-outlet></router-outlet>
  </div>
  @if (appService.showNavOverlay && user) {
    <myp-cloud-nav-overlay></myp-cloud-nav-overlay>
  }
  <myp-image-viewer></myp-image-viewer>
  <myp-video-player></myp-video-player>
  <myp-action></myp-action>
  <myp-notification></myp-notification>
  <ngx-spinner type="line-scale-pulse-out"></ngx-spinner>

  @if (userService.needsToLinkFenderAccount && showLinkAccountNoticeIfNecessary) {
    <div class="link-account-notice">
      <div class="d-flex align-items-center">
        <fa-icon icon="exclamation-triangle" class="m-r-10 c-red t-30"></fa-icon>
        {{ "link_accounts.you_need_to" | translate }}
      </div>
      <div>
        <button (click)="linkFenderAccount()" class="btn btn-primary m-r-10">{{ "link_accounts.link_btn" | translate }}</button>
        <button class="btn btn-blank btn-sm" (click)="showLinkAccountNoticeIfNecessary = false">{{ "link_accounts.do_this_later" | translate }}</button>
      </div>
    </div>
  }
</div>
